
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M18.3639 18.614C18.64 18.614 18.8639 18.3901 18.8639 18.114L18.8639 13.614C18.8639 13.3378 18.6401 13.114 18.3639 13.114C18.0878 13.114 17.8639 13.3378 17.8639 13.614L17.8639 17.614L13.8639 17.614C13.5878 17.614 13.3639 17.8378 13.3639 18.114C13.3639 18.3901 13.5878 18.614 13.8639 18.614L18.3639 18.614ZM5.28243 5.7396L5.91883 6.376L6.62594 5.66889L5.98954 5.03249L5.28243 5.7396ZM7.19162 7.64879L8.46441 8.92158L9.17152 8.21447L7.89873 6.94168L7.19162 7.64879ZM9.73721 10.1944L11.01 11.4672L11.7171 10.7601L10.4443 9.48727L9.73721 10.1944ZM12.2828 12.74L13.5556 14.0128L14.2627 13.3056L12.9899 12.0329L12.2828 12.74ZM14.8284 15.2855L16.1012 16.5583L16.8083 15.8512L15.5355 14.5784L14.8284 15.2855ZM17.374 17.8311L18.0104 18.4675L18.7175 17.7604L18.0811 17.124L17.374 17.8311Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiTextRightOblique",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
